<app-header></app-header>
<!--Breadcrumb-->
        <section>
            <div class="bannerimg cover-image bg-background3" data-image-src="assets/images/banners/banner2.jpg">
                <div class="header-text mb-0">
                    <div class="container">
                        <div class="text-center">
                            <h1 class="">My Inspections</h1>
                            <!--ol class="breadcrumb text-center">
                                <li class="breadcrumb-item"><a href="home.html">Home</a></li>
                                <li class="breadcrumb-item active text-white">My Dashboard</li>
                                <li class="breadcrumb-item active text-white" aria-current="page">My Preferences</li>
                            </ol-->
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!--Breadcrumb-->

        <!--Section-->
        <section class="sptb">
            <div class="container">
                <div class="row">
                    <div class="col-xl-3 col-lg-12 col-md-12">
                        <!-- my account left menu -->
                <app-my-account-left-menu></app-my-account-left-menu>
                <!-- /my account left menu -->
                    </div>
                    <div class="col-xl-9 col-lg-12 col-md-12">
                        <div class="card mb-0">
                            <div class="card-header d-sm-flex title-set">
                                <h3 class="card-title col-md-8">My Inspections List</h3>
                                <div class="col-md-4">
                                 
                                    
                                    <div class="evaluate_attemp1">
                                        <select class="form-control select2-show-search border-bottom-0 w-100 select2-show-search" data-placeholder="Select" onchange="if(this.value=='all'){$('#short-filter_filter input').val('');}else{$('#short-filter_filter input').val(this.value);}$('#short-filter_filter input').keyup()">
                                            <optgroup label="Filter By Status">
                                                <option value="all">Filter By Status</option>
                                                <option value="all">All</option>
                                                <option value="Pending">Pending</option>
                                                <option value="Completed">Completed</option>
                                            </optgroup>
                                        </select>
                                    </div>
                                    
                        
                                </div>
              <!--                   <div class="col-md-6">-->
              <!--                   <label class="selectgroup-item mb-md-0">-->
														<!--	<input type="radio" name="value" value="Latest" class="selectgroup-input">-->
														<!--	<span class="selectgroup-button">Latest <i class="fa fa-sort ml-1"></i></span>-->
														<!--</label>-->
														<!--</div>-->
                            </div>
                            <div class="padding_125">
                                <div class="table-responsive">
                                    <table id="short-filter" class="table table-striped table-bordered text-nowrap text-center">
                                        <thead>
                                            <tr>
                                                <th>Image</th>
                                                <th>Detail</th>												
                                                <th>REG NO</th>
                                                <th>Evaluate Date</th>
                                                <th>Status</th>
                                                <th>Assignement Date</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let item of carsList">
                                                <td><img src="{{item.pic_1}}" alt="img" class="cover-image"></td>
                                                <td>{{item.title}} </td>
                                                <td>{{item.registration_no}}</td>
                                                <td>{{item.evaluate_date}}</td>                                                                                                
                                                <td>{{item.evaluate_status}}</td>
                                                <td>{{item.created_date_time  |  dateAgo}}</td>
                                                
                                                <td>
                                                    <a class="btn btn-primary btn-sm text-white mb-1 cursor_pointer" data-toggle="tooltip" data-original-title="View" (click)="carDetail(item.sale_by,item.id);">
                                                        <i class="fa fa-eye"></i>
                                                    </a>
                                                    <a class="btn btn-success btn-sm text-white mb-1 cursor_pointer" data-toggle="tooltip" data-original-title="Edit" (click)="inspectionDetail(item.id)">
                                                        <i class="fa fa-pencil"></i>
                                                    </a>
                                                </td>
                                            </tr>                                            
                                        </tbody>
                                    </table>
                                </div>                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
               
                 
    </section>
    <!--/Section-->

    <app-footer></app-footer>
